export class PreferenceMessages {

  public title = 'preference.title';

  public modal_star_content ='preference.modal_star.content'
  public modal_star_confirmer ='preference.modal_star.confirmer'
  public modal_star_retour ='preference.modal_star.retour'

  public modal_partage_content ='preference.modal_partage.content'
  public modal_partage_content_bis ='preference.modal_partage.content_bis'
  public modal_partage_confirmer ='preference.modal_partage.confirmer'
  public modal_partage_retour ='preference.modal_partage.retour'
  public modal_partage_code ='preference.modal_partage.code'
  public modal_partage_wrong_code ='preference.modal_partage.wrong_code'
  public modal_partage_button_label ='preference.modal_partage.button_label'
  public modal_partage_button_label_acheteur ='preference.modal_partage.button_label_acheteur'

  public modal_diffuseur_content ='preference.modal_diffuseur.content'
  public modal_diffuseur_intitule ='preference.modal_diffuseur.intitule'
  public modal_diffuseur_confirmer ='preference.modal_diffuseur.confirmer'
  public modal_diffuseur_retour ='preference.modal_diffuseur.retour'
  public modal_diffuseur_button_label ='preference.modal_diffuseur.button_label'

  public modal_presse_spe_button_label ='preference.modal_presse_spe.button_label';

  public modal_delete_text ='preference.modal_delete_text'
  public modal_create_text ='preference.modal_create_text'
  public modal_update_text ='preference.modal_update_text'

  public tab_1_label_1 = 'preference.tab_1.label_1';
  public tab_2_label_1 = 'preference.tab_2.label_1';
  public tab_3_label_1 = 'preference.tab_3.label_1';
  public tab_4_label_1 = 'preference.tab_4.label_1';
  public tab_5_label_1 = 'preference.tab_5.label_1';
  public tab_6_label_1 = 'preference.tab_6.label_1';

  public tab_1_label_2 = 'preference.tab_1.label_2';
  public tab_1_label_3 = 'preference.tab_1.label_3';
  public tab_1_label_4 = 'preference.tab_1.label_4';
  public tab_1_label_5 = 'preference.tab_1.label_5';
  public tab_1_label_6 = 'preference.tab_1.label_6';
  public tab_1_label_7 = 'preference.tab_1.label_7';
  public tab_1_label_8 = 'preference.tab_1.label_8';
  public tab_1_label_9 = 'preference.tab_1.label_9';
  public tab_1_label_10 = 'preference.tab_1.label_10';
  public tab_1_label_11 = 'preference.tab_1.label_11';
  public tab_1_label_12_part1 = 'preference.tab_1.label_12_part1';
  public tab_1_label_12_part2 = 'preference.tab_1.label_12_part2';

  public tab_2_label_2 = 'preference.tab_2.label_2';
  public tab_2_label_3 = 'preference.tab_2.label_3';
  public tab_2_retour = 'preference.tab_2.retour';
  public tab_2_label_4 = 'preference.tab_2.label_4';
  public tab_2_label_4_bis = 'preference.tab_2.label_4_bis';
  public tab_2_label_5 = 'preference.tab_2.label_5';
  public tab_2_label_5_bis = 'preference.tab_2.label_5_bis';
  public tab_2_label_6_part1 = 'preference.tab_2.label_6_part1';
  public tab_2_label_6_part2 = 'preference.tab_2.label_6_part2';
  public tab_2_label_intitule = 'preference.tab_2.label_intitule';
  public tab_2_label_7 = 'preference.tab_2.label_7';
  public tab_2_reset = 'preference.tab_2.reset';
  public tab_2_label_8 = 'preference.tab_2.label_8';
  public tab_2_resultat = 'preference.tab_2.resultat';
  public tab_2_resultat_error = 'preference.tab_2.resultat_error';
  public tab_2_label_9 = 'preference.tab_2.label_9';
  public tab_2_max_liste_error = 'preference.tab_2.max_liste_error';

  public tab_3_label_2 = 'preference.tab_3.label_2';
  public tab_3_label_3 = 'preference.tab_3.label_3';
  public tab_3_label_4 = 'preference.tab_3.label_4';
  public tab_3_label_5 = 'preference.tab_3.label_5';
  public tab_3_error_1 = 'preference.tab_3.error_1';
  public tab_3_error_2 = 'preference.tab_3.error_2';


  public tab_4_label_2 = 'preference.tab_4.label_2';
  public tab_4_label_2_bis = 'preference.tab_4.label_2_bis';
  public tab_4_label_3 = 'preference.tab_4.label_3';
  public tab_4_label_4_part1 = 'preference.tab_4.label_4_part1';
  public tab_4_label_4_part2 = 'preference.tab_4.label_4_part2';
  public tab_4_label_ajouter = 'preference.tab_4.label_ajouter';
  public tab_4_label_annuler = 'preference.tab_4.label_annuler';
  public tab_4_label_modifier = 'preference.tab_4.label_modifier';

  public tab_4_label_intitule = 'preference.tab_4.label_intitule';
  public tab_4_label_organisme = 'preference.tab_4.label_organisme';
  public tab_4_label_classe_profit = 'preference.tab_4.label_classe_profit';
  public tab_4_label_siret = 'preference.tab_4.label_siret';
  public tab_4_label_type_entite = 'preference.tab_4.label_type_entite';
  public tab_4_label_identifiant_adressage = 'preference.tab_4.label_identifiant_adressage';
  public tab_4_label_ref_bon_commande = 'preference.tab_4.label_ref_bon_commande';
  public tab_4_label_executant = 'preference.tab_4.label_executant';
  public tab_4_label_engagement = 'preference.tab_4.label_engagement';
  public tab_4_label_destinataire = 'preference.tab_4.label_destinataire';
  public tab_4_label_immeuble = 'preference.tab_4.label_immeuble';
  public tab_4_label_voie = 'preference.tab_4.label_voie';
  public tab_4_label_complement = 'preference.tab_4.label_complement';
  public tab_4_label_cp = 'preference.tab_4.label_cp';
  public tab_4_label_pays = 'preference.tab_4.label_pays';
  public tab_4_label_ville = 'preference.tab_4.label_ville';
  public tab_4_label_tva = 'preference.tab_4.label_tva';


  public tab_5_label_2 = 'preference.tab_5.label_2';
  public tab_5_label_2_bis = 'preference.tab_5.label_2_bis';
  public tab_5_label_ajouter = 'preference.tab_5.label_ajouter';
  public tab_5_label_annuler = 'preference.tab_5.label_annuler';
  public tab_5_label_modifier = 'preference.tab_5.label_modifier';

  public tab_5_label_identifiant = 'preference.tab_5.label_identifiant';
  public tab_5_label_emailboamp = 'preference.tab_5.label_emailboamp';

  public tab_6_label_2 = 'preference.tab_6.label_2';
  public tab_6_label_3 = 'preference.tab_6.label_3';
  public tab_6_label_4 = 'preference.tab_6.label_4';
  public tab_6_retour = 'preference.tab_6.retour';
  public tab_6_label_intitule = 'preference.tab_6.intitule';
  public tab_6_sous_titre_1 = 'preference.tab_6.sous_titre_1';
  public tab_6_label_personne_physique = 'preference.tab_6.label_personne_physique';
  public tab_6_label_nom_officiel = 'preference.tab_6.label_nom_officiel';
  public tab_6_label_num_enregistrement = 'preference.tab_6.label_num_enregistrement';
  public tab_6_label_departement = 'preference.tab_6.label_departement';
  public tab_6_label_adresse_internet = 'preference.tab_6.label_adresse_internet';
  public tab_6_label_url_echange_information = 'preference.tab_6.label_url_echange_information';
  public tab_6_sous_titre_2 = 'preference.tab_6.sous_titre_2';
  public tab_6_label_Adr1 = 'preference.tab_6.label_Adr1';
  public tab_6_label_Adr2 = 'preference.tab_6.label_Adr2';
  public tab_6_label_Adr3 = 'preference.tab_6.label_Adr3';
  public tab_6_label_ville = 'preference.tab_6.label_ville';
  public tab_6_label_cp = 'preference.tab_6.label_cp';
  public tab_6_label_entite_secondaire = 'preference.tab_6.label_entite_secondaire';
  public tab_6_label_pays = 'preference.tab_6.label_pays';
  public tab_6_sous_titre_3 = 'preference.tab_6.sous_titre_3';
  public tab_6_label_point_contact = 'preference.tab_6.label_point_contact';
  public tab_6_label_email = 'preference.tab_6.label_email';
  public tab_6_label_telephone = 'preference.tab_6.label_telephone';
  public tab_6_label_telecopieur = 'preference.tab_6.label_telecopieur';
  public tab_6_label_5 = 'preference.tab_6.label_5';
  public tab_6_ajouter = 'preference.tab_6.label_ajouter';
  public tab_6_modifier = 'preference.tab_6.label_modifier';

  constructor() {
  }
}
